








































































































































import ProjectHead from '../components/ProjectHead.vue';
import FileList from '../components/FileList.vue';
import SaveStatusWrapper from '../components/SaveStatusWrapper.vue';
import SourceCode from '../components/SourceCode.vue';
import ReferenceX1 from '../components/ReferenceX1.vue';
import emulator from '../emulator/Emulator';
import Vue from 'vue';
import {Breakpoint} from '@/types/Breakpoint';
import Project, {ProjectFile} from '@/types/Project';
import {CompilerBinaryOutput, CompilerError} from '@/emulator/CompilerOutput';
import ErrorInfo from '@/components/types/ErrorInfo';
import downloadProjectFiles from '@/util/downloadProject';

enum State {
    Edit = 'Edit',
    ClosingProject = 'ClosingProject',
    LoadingProject = 'LoadingProject',
    Error = 'Error',
}

export default Vue.extend({
    name: 'editor',

    components: {
        ProjectHead, FileList, SaveStatusWrapper, SourceCode, ReferenceX1,
    },

    data() : {
        selectedFile: string,
        state: State,
        error?: ErrorInfo,
        loadingError?: string,
        isWaiting: boolean,
    } {
        return {
            selectedFile: 'main.s',
            state: (this.$store.state.project.projectDef !== undefined && this.$store.state.project.projectDef!.id === this.$route.params.id) ? State.Edit : State.LoadingProject,
            error: undefined,
            isWaiting: false,
        };
    },

    computed: {
        project() : Project {
            return this.$store.state.project.projectDef!.project;
        },

        breakpoints() : Breakpoint[] {
            return this.$store.state.breakpoints.list
              .filter((i: Breakpoint) => i.filename === this.selectedFile)
              .map((i: Breakpoint) => i.line);
        },
    },

    methods: {
        async closeProject() : Promise<void> {
            if (this.state !== State.ClosingProject) {
                if (window.confirm('Are you sure you want to close this project?')) {
                    this.state = State.ClosingProject;
                    await this.$store.dispatch('project/close');
                    // this.state = State.LoadingProject;
                    await this.$router.push('/projects');
                }
            }
        },

        newFile(filename: string) : void {
            this.$store.commit('project/CREATE_FILE', { name: filename, content: '' } as ProjectFile);
            if (this.$store.state.project.files.filter((f: ProjectFile) => f.name === filename).length > 0) {
                this.selectedFile = filename;
                // this.$refs.sourceCode.focus();
            }
        },

        deleteFile() : void {
            if (window.confirm(`Are you sure you want to delete the file '${this.selectedFile}'?`))
                this.$store.commit('project/DELETE_FILE', this.selectedFile);
            this.selectedFile = 'main.s';
        },

        async compileAndRun(debug: boolean) : Promise<void> {
            this.isWaiting = true;
            try {
                const e = await emulator(this.$store.state.project.projectDef!.project.archVersion);
                const filename = 'output.bin';
                const output = e.compile(this.$store.state.project.files);
                if (process.env.NODE_ENV === 'development') {
                    console.log('Compiler output:');
                    console.log(output);
                }
                if ((output as CompilerError).error) {
                    // compilation error
                    const o = output as CompilerError;
                    this.selectedFile = o.file!;
                    this.error = {filename: o.file, message: o.error, line: o.line!};
                    // @ts-ignore
                    this.$refs.sourceCode.scrollTo(o.line + 1);
                } else {
                    // compilation sucessful
                    const o = output as CompilerBinaryOutput;
                    this.$store.commit('project/SAVE_FILE', {name: filename, content: o.binary});
                    this.$store.commit('project/SAVE_FILE', {
                        name: 'output.dbg',
                        content: JSON.stringify(o.debuggingInfo),
                    });
                    if (debug)
                        await this.$router.push('/debugger');
                    else
                        await this.$router.push('/debugger?run=1');
                }
            } catch (err) {
                this.selectedFile = 'main.s';
                this.error = { filename: 'main.s', line: 1, message: err.message };
            }
            this.isWaiting = false;
        },

        downloadProjectFiles,
    },

    async mounted() {
        try {
            if (this.$store.state.project.projectDef === undefined || this.$store.state.project.projectDef!.id !== this.$route.params.id)
                await this.$store.dispatch('project/load', this.$route.params.id);
            this.state = State.Edit;
        } catch (e) {
            this.state = State.Error;
            this.loadingError = e.message;
        }
    },

    async beforeDestroy() {
        if (this.$store.state.project.dirty) {
            await this.$store.dispatch('autosave/autosave');
        }
    },
});
